<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <DxToolbar>
        <DxItem
          #default
          location="after"
          locate-in-menu="auto"
          >
          <dx-button  class='save-button'
            icon='save'
            text='저장'
            type="default"
            styling-mode="contained"
            :focusStateEnabled = 'true'
            :width='100'
            @click="onPermissionSave($event)"
          />
        </DxItem>
      </DxToolbar>
      <div class='menu-tree-list'>
        <dx-tree-list
          id="menu-list"
          :height='700'
          :data-source="menuList"
          :autoExpandAll='true'
          :show-borders="true" :showRowLines = 'true'
          :column-auto-width="true"
          items-expr="subMenu"
          data-structure="tree"
          :selection="{ mode: 'single' }" :hover-state-enabled = "true"
        >
          <dx-column
            data-field="caption"
            caption="메뉴명"
            :allow-sorting="false"
            width='210'
          />

          <dx-column
            data-field="userGroup"
            caption="접근권한"
            :allow-sorting="false"
            cell-template="cellTemplate"
          />
          <template #cellTemplate="{ data }">
            <div>
              <dx-check-box v-for='(sub, index1)  in data.value' :key="index1" style='margin-left:10px;'
                v-model = 'sub.checked'
                :text = 'sub.groupName'
                :disabled='index1===0'
                width='106'
              />
            </div>
          </template>
          <dx-column
            data-field="url"
            caption="URL"
            :allow-sorting="false"
            width='150'
          />
        </dx-tree-list>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
/*
import HttpService from '../share/service/HttpService'
import ConstDef from '../share/ConstDef'
import Loading from 'vue-loading-overlay'
*/
import ConstDef from '../../share/ConstDef'
import Loading from 'vue-loading-overlay'
import { DxTreeList, DxColumn } from 'devextreme-vue/tree-list'
import { DxCheckBox } from 'devextreme-vue/check-box'
import { DxButton } from 'devextreme-vue'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'

export default {
  name: 'menuPermission',
  data: function () {
    return {
      isLoading: false,
      allHidden: false,
      menuList: null,
      saveButtonOptions: {
        text: '저장',
        onClick: () => {
          this.onPermissionSave()
        }
      }
    }
  },
  components: {
    Loading,
    DxTreeList,
    DxColumn,
    DxCheckBox,
    DxButton,
    DxToolbar,
    DxItem
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    this.menuList = this.$store.getters.getTopMenu
    console.log(this.menuList)
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onPermissionSave () {
      console.log(this.menuList)
      this.isLoading = true
      const saveMenuList = []
      for (let i = 0; i < this.menuList.length; i++) {
        const item = {}
        item.menuId = this.menuList[i].menuId
        let bitmask = 0x01
        for (let j = 0; j < this.menuList[i].userGroup.length; j++) {
          if (this.menuList[i].userGroup[j].checked === true) {
            bitmask = bitmask | this.menuList[i].userGroup[j].permission
          }
        }

        item.permission = bitmask
        saveMenuList.push(item)
        for (let k = 0; k < this.menuList[i].subMenu.length; k++) {
          // console.log(this.menuList[i].subMenu.length)
          const subItem = {}
          subItem.menuId = this.menuList[i].subMenu[k].menuId
          let subBit = 0x01
          for (let l = 0; l < this.menuList[i].userGroup.length; l++) {
            if (this.menuList[i].subMenu[k].userGroup[l].checked === true) {
              subBit = subBit | this.menuList[i].subMenu[k].userGroup[l].permission
            }
          }
          subItem.permission = subBit
          saveMenuList.push(subItem)
        }
      }
      console.log(saveMenuList)
      this.$_sp.runUpdateProc('spUpdateTopMenuByMenuId', saveMenuList)
        .then((data) => {
          // console.log(data)
          if (data.result === ConstDef.SUCCESS) {
            this.$store.commit('saveTopmenu', this.menuList)
            this.$snotify.info('저장 되었습니다.')
          } else {
            this.$snotify.error('메뉴 권한 수정 실패')
          }
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }

  }
}
</script>

<style lang="scss">
.sub-page{
  .menu-tree-list {
    margin-top:6px;
    text-align: center;
  }
  .save-button {
    font-weight: 700;
    .dx-button-text{
      font-size: 1.1rem;
    }
  }
  .dx-selection{
    .dx-checkbox-text{
      color:white;
    }
  }
}

</style>
